import React from "react";

export default function AgenciesPage() {
  return (
	<div className="aqx-main-inner">
	  <div className="aqx-main-header">
		<h1>Agencies</h1>
		<p>Operator Agencies placeholder. This page will manage operator agency affiliations.</p>
	  </div>
	</div>
  );
}